import { render, staticRenderFns } from "./CmgLoyaltyRewardsModal.vue?vue&type=template&id=48ea7ab2&scoped=true&lang=pug&"
import script from "./cmg-loyalty-rewards-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-loyalty-rewards-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgLoyaltyRewardsModal.vue?vue&type=style&index=0&id=48ea7ab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ea7ab2",
  null
  
)

export default component.exports